import script from "./MineralFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./MineralFilter.vue?vue&type=script&setup=true&lang=js"

import "./MineralFilter.vue?vue&type=style&index=0&id=9eb2af1a&lang=css&scoped=true"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9eb2af1a"]])

export default __exports__